import _ from 'lodash';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { decode as base64_decode } from 'base-64';
import FileBase64 from '../../../Utils/FileUpload';
import { constant } from '../../../Utils/constants';
import WorkOrderJobPlanes from './WorkOrderJobPlanes';
import React, { useEffect, useRef, useState } from 'react';
// import localStorage from '../../../../../utils/localStorage';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';

import { Form, message, Select, DatePicker, Input, Typography,Button } from 'antd';
import {
  getDeviceList,
  getOrganisationsList,
  getSitesList,
  submitWorkOrder,
  getJobPlansList,
  // getJobPlanById,
  getLocationByAsset,
  getWorkTypes,
  getWorkFlows,
  getStatus,
  getWorkOrderById,
  getPMList,
  getUsersList
} from '../../../Utils/FormCalls';
import {
  StyledBox,
  StyledBoxLabel
} from '../../../CSS/style';

const { Option } = Select;
const { TextArea } = Input;

const WorkOrderForm = (props) => {
  const workOrderRef = useRef();
  const [state, setState] = useState({
    deviceList: [],
    organisationsList: [],
    sitesList: [],
    workTypesList: [],
    workFlowsList: [],
    statusList: [],
    usersList: [],
    activeKey: '1',
    selectedJobPlan: props.formObject && props.formObject.JobPlanName ? props.formObject.JobPlanName : '',
    jobplanActivekey: '1',
    translationCache: props.translationCache || {},
    fileUploadList: [],
    noJobplan: false
  });
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      const sitesList = await getSitesList();
      // let formObject = workOrderRef.current.getFieldsValue();
      // formObject = {
      //   ...formObject,
      //   SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      // };
      // workOrderRef.current.setFieldsValue(formObject);
      // setFormObject(formObject);
      setState(prevState => ({ ...prevState, sitesList }));

      const deviceList = await getDeviceList();
      setState(prevState => ({ ...prevState, deviceList }));

      const organisationsList = await getOrganisationsList();
      setState(prevState => ({ ...prevState, organisationsList }));

      const JobPlansList = await getJobPlansList('Active');
      setState(prevState => ({ ...prevState, JobPlansList }));

      const workTypesList = await getWorkTypes();
      setState(prevState => ({ ...prevState, workTypesList }));

      const usersList = await getUsersList();
      setState(prevState => ({ ...prevState, usersList }));

      const Status = await getStatus();
      setState(prevState => ({ ...prevState, statusList: Status }));

      const PMList = await getPMList();
      setState(prevState => ({ ...prevState, PMList }));
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    // if (props.formObject && Object.keys(props.formObject).length === 0) {
    //   workOrderRef.current.setFieldsValue(props.formObject);
    // }
    // if (props.translationCache !== state.translationCache) {
    //   setState(prevState => ({ ...prevState, translationCache: props.translationCache }));
    // }
  }, [props.formObject, props.translationCache]);

  const _getDataById = async (Id) => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/FieldDataMeasurementDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new' && !Id) {
      formObject = await getWorkOrderById(base64_decode(path[1]), 'withId');
      _.cloneDeepWith(formObject, (value) => {
        return value !== null
          ? {
            ...value,
            ...(value['RecordedTime']
              ? (value['RecordedTime'] = dayjs
                .utc(value.RecordedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['JobPlan'] &&
              value['JobPlan']['TaskData'] &&
              value['JobPlan']['TaskData'].map((item, i) => {
                return value['JobPlan']['TaskData'][i]
                  ? (value['JobPlan']['TaskData'][i]['StartTime']
                    ? (value['JobPlan']['TaskData'][i]['StartTime'] = dayjs
                      .utc(
                        value['JobPlan']['TaskData'][i]['StartTime'],
                        'YYYY-MM-DD HH:mm:ss'
                      )
                      .local())
                    : null,
                    value['JobPlan']['TaskData'][i]['EndTime']
                      ? (value['JobPlan']['TaskData'][i]['EndTime'] = dayjs
                        .utc(value['JobPlan']['TaskData'][i]['EndTime'], 'YYYY-MM-DD HH:mm:ss')
                        .local())
                      : null,
                    value['JobPlan']['TaskData'][i]['MeasurementDate']
                      ? (value['JobPlan']['TaskData'][i]['MeasurementDate'] = dayjs
                        .utc(
                          value['JobPlan']['TaskData'][i]['MeasurementDate'],
                          'YYYY-MM-DD HH:mm:ss'
                        )
                        .local())
                      : null,
                    value['JobPlan']['TaskData'][i]['EstimatedDuration']
                      ? (value['JobPlan']['TaskData'][i]['EstimatedDuration'] = dayjs
                        .utc(
                          value['JobPlan']['TaskData'][i]['EstimatedDuration'],
                          'YYYY-MM-DD HH:mm:ss'
                        )
                        .local())
                      : null,
                    value['JobPlan']['TaskData'][i]['PlannedDate']
                      ? (value['JobPlan']['TaskData'][i]['PlannedDate'] = dayjs
                        .utc(
                          value['JobPlan']['TaskData'][i]['PlannedDate'],
                          'YYYY-MM-DD HH:mm:ss'
                        )
                        .local())
                      : null)
                  : null;
              })),
            ...(value['JobPlan'] &&
              value['JobPlan']['ActualTaskData'] &&
              value['JobPlan']['ActualTaskData'].map((item, i) => {
                return value['JobPlan']['ActualTaskData'][i]
                  ? value['JobPlan']['ActualTaskData'][i]['ActualDate']
                    ? (value['JobPlan']['ActualTaskData'][i]['ActualDate'] = dayjs
                      .utc(
                        value['JobPlan']['ActualTaskData'][i]['ActualDate'],
                        'YYYY-MM-DD HH:mm:ss'
                      )
                      .local())
                    : null
                  : null;
              }))
          }
          : _.noop();
      });
      setFormObject(formObject);

    } else if (Id) {
      formObject = await getWorkOrderById(Id, 'withId');
      _.cloneDeepWith(formObject, (value) => {
        return value !== null
          ? {
            ...value,
            ...(value['RecordedTime']
              ? (value['RecordedTime'] = dayjs
                .utc(value.RecordedTime, 'YYYY-MM-DD HH:mm:ss')
                .local())
              : null),
            ...(value['JobPlan'] &&
              value['JobPlan']['TaskData'] &&
              value['JobPlan']['TaskData'].map((item, i) => {
                return value['JobPlan']['TaskData'][i]
                  ? (value['JobPlan']['TaskData'][i]['StartTime']
                    ? (value['JobPlan']['TaskData'][i]['StartTime'] = dayjs
                      .utc(
                        value['JobPlan']['TaskData'][i]['StartTime'],
                        'YYYY-MM-DD HH:mm:ss'
                      )
                      .local())
                    : null,
                    value['JobPlan']['TaskData'][i]['EndTime']
                      ? (value['JobPlan']['TaskData'][i]['EndTime'] = dayjs
                        .utc(value['JobPlan']['TaskData'][i]['EndTime'], 'YYYY-MM-DD HH:mm:ss')
                        .local())
                      : null,
                    value['JobPlan']['TaskData'][i]['MeasurementDate']
                      ? (value['JobPlan']['TaskData'][i]['MeasurementDate'] = dayjs
                        .utc(
                          value['JobPlan']['TaskData'][i]['MeasurementDate'],
                          'YYYY-MM-DD HH:mm:ss'
                        )
                        .local())
                      : null,
                    value['JobPlan']['TaskData'][i]['EstimatedDuration']
                      ? (value['JobPlan']['TaskData'][i]['EstimatedDuration'] = dayjs
                        .utc(
                          value['JobPlan']['TaskData'][i]['EstimatedDuration'],
                          'YYYY-MM-DD HH:mm:ss'
                        )
                        .local())
                      : null,
                    value['JobPlan']['TaskData'][i]['PlannedDate']
                      ? (value['JobPlan']['TaskData'][i]['PlannedDate'] = dayjs
                        .utc(
                          value['JobPlan']['TaskData'][i]['PlannedDate'],
                          'YYYY-MM-DD HH:mm:ss'
                        )
                        .local())
                      : null)
                  : null;
              })),
            ...(value['JobPlan'] &&
              value['JobPlan']['ActualTaskData'] &&
              value['JobPlan']['ActualTaskData'].map((item, i) => {
                return value['JobPlan']['ActualTaskData'][i]
                  ? value['JobPlan']['ActualTaskData'][i]['ActualDate']
                    ? (value['JobPlan']['ActualTaskData'][i]['ActualDate'] = dayjs
                      .utc(
                        value['JobPlan']['ActualTaskData'][i]['ActualDate'],
                        'YYYY-MM-DD HH:mm:ss'
                      )
                      .local())
                    : null
                  : null;
              }))
          }
          : _.noop();
      });
    }
    handleChange(
      formObject && formObject.JobPlan && formObject.JobPlan.JobPlanName,
      'JobPlanName'
    );
    handleChange(
      formObject && formObject.JobPlan && formObject.JobPlan.JobPlanName,
      'JobPlanDescription'
    );

    // setState(prevState => ({
    //   ...prevState,
    //   formObject
    // }));
    setFormObject(formObject);

    if (formObject && workOrderRef.current) {
      workOrderRef.current.setFieldsValue(formObject);
    }
  };

  // const handleSelect = (value, mainIndex, subindex, keyName) => {
  //   let list = {};
  //   let TaskData = list;
  //   TaskData.map((item, index) => {
  //     if (index === mainIndex) {
  //       item[keyName][subindex]['TotalQuantity'] = value;
  //     }
  //     return {};
  //   });
  // };

  const handleChange = async (value, key) => {
    let { deviceList, PMList, JobPlansList } = state;
    let FormObject = formObject;
    FormObject = {
      ...FormObject,
      [key]: value
    };
    if (key === 'DeviceId') {
      let selectedDevice = deviceList.filter((item) => item.Id === value);
      let location = await getLocationByAsset(selectedDevice[0]);
      FormObject = {
        ...FormObject,
        [key]: value,
        EquipmentDescription: selectedDevice[0].Name,
        LocationId: location.Name
      };
    } else if (key === 'PM') {
      let selectedDevice = PMList.filter((item) => item.Id === value);
      FormObject = {
        ...FormObject,
        [key]: value,
        PMDescription: selectedDevice[0].Name
      };
    } else if (key === 'JobPlanId') {
      let selectedDevice = JobPlansList.filter((item) => item.Id === value);
      FormObject = {
        ...FormObject,
        [key]: value,
        JobPlanDescription: selectedDevice[0].JobPlanDescription
      };
    } else if (key === 'WorkTypeId') {
      var workFlowsList = await getWorkFlows(value);
    }
    FormObject = {
      ...FormObject,
      [key]: value
    };
    workOrderRef.current && workOrderRef.current.setFieldsValue(FormObject);
    setFormObject(FormObject);
    setState(prevState => ({ ...prevState, workFlowsList }));
  };

  const fileupload = async (values, key, fileDataObject) => {
    let formObject = workOrderRef.current.getFieldsValue();
    let { fileUploadList } = state;
    if (formObject && formObject[key]) {
      formObject[key].push(...values);
    } else if (formObject[key] !== undefined) {
      formObject[key] = values;
    } else {
      formObject[key].push({ [key]: values });
    }
    formObject[key] =
      formObject[key] &&
      formObject[key].reduce((acc, current) => {
        const x = acc.find((item) => item.Name === current.Name);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);

    formObject = {
      ...formObject,
      [key]: formObject[key]
    };
    let WO = [...(fileUploadList && fileUploadList.WO ? fileUploadList.WO : [])];
    WO.push({ fileDataObject });
    fileUploadList = {
      ...fileUploadList,
      WO
    };
    if (workOrderRef.current) workOrderRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setState(prevState => ({ ...prevState, fileUploadList }));
  };

  const onFinish = async (values, key, fileData) => {

 
  let validateTaskData = true;

  // Check if the FieldDataType panel is opened
  const isFieldDataTypePanelOpened = values.TaskData.some(task => task.FieldDataType && task.FieldDataType.length > 0);

  values &&
    values['TaskData'] &&
    values['TaskData'].forEach((val) => {
      if (
        val &&
        Object.keys(val).includes('TaskName') &&
        Object.keys(val).includes('TaskDescription')
      ) {
        if (val.Id === undefined) {
          if (val.FieldDataType && val.FieldDataType.length > 0) {
            
            val.FieldDataType.forEach((field) => {
              if (!field || !field.Name?.trim() || !field.Description?.trim()) {
                validateTaskData = false;
                message.error("Please fill name and description in FieldDataType");
              }
            });
          } else {
            
            validateTaskData = false;
            message.warning('Please add FieldDataType in New Task');
          }
        }
      } else {
        validateTaskData = false;
        message.error('Please enter mandatory fields in Planned Task');
      }
    });

  if (!isFieldDataTypePanelOpened) {
    message.warning('Please open the FieldDataType panel and fill in the required fields before submitting.');
    return; 
  }

  setState(prevState => ({
    ...prevState,
    noJobplan: validateTaskData
  }));

 

    values &&
      values['ActualTaskData'] &&
      values['ActualTaskData'].map((val, index) => {
        if (
          values['ActualTaskData'][index] &&
          Object.keys(values['ActualTaskData'][index]).includes('TaskName') &&
          Object.keys(values['ActualTaskData'][index]).includes('TaskDescription')
        ) {
          let formObject = workOrderRef.current.getFieldsValue();
          formObject = {
            ...formObject,
            [key]: {
              ...formObject[key],
              ...values
            }
          };
          setState({ formObject, fileData });
          workOrderRef.current.setFieldsValue(formObject);
        } else {
          validateTaskData = false;
          message.error('Please enter Mandatory fileds in Actual Task');
        }
        return {};
      });
    setState(prevState => ({
      ...prevState,
      noJobplan: validateTaskData
    }));

  };



  const nojobpaln = () => {
    setState(prevState => ({
      ...prevState,
      noJobplan: false
    }));
  };


  const onFormsubmit = async () => {
    
    let { noJobplan, fileUploadList } = state;
   
    let formdata = workOrderRef.current.getFieldsValue();
    setState(prevState => ({
      ...prevState,
      noJobplan: false
    }));
    let FormObject = formObject;
    FormObject = {
      ...FormObject,
      Summary: formdata.Summary
    };
    let ToolData = null;
    let ManPowerData = null;
    let MaterialData = null;
    let ItemsData = null;
    let FieldDataTypeData = null;


    if (FormObject &&
      FormObject.JobPlan &&
      FormObject.JobPlan.TaskData &&
      Array.isArray(FormObject.JobPlan.TaskData)) {

      FormObject.JobPlan.TaskData.forEach((item) => {
        if (item.Tools && item.Tools.includes(null)) {
          ToolData = true;
        }
        if (item.Labor && item.Labor.includes(null)) {
          ManPowerData = true;
        }
        if (item.Materials && item.Materials.includes(null)) {
          MaterialData = true;
        }
        if (item.Items && item.Items.includes(null)) {
          ItemsData = true;
        }
        if(item.FieldDataType && item.FieldDataType.includes(null)){
          FieldDataTypeData = true;
        }
      });
    }

    if (ToolData === true) {
      message.warn('Please Add Mandatory Fields In Tools');
    } else if (ManPowerData === true) {
      message.warn('Please Add Mandatory Fields In ManPower');
    } else if (MaterialData === true) {
      message.warn('Please Add Mandatory Fields In Materials');
    } else if (ItemsData === true) {
      message.warn('Please Add Mandatory Fields In Items');
    }
    else if (FieldDataTypeData === true){
      message.warn("Please Add Mandatory Fields In FieldDataType");
    }

    if (
      noJobplan === true &&
      FormObject.JobPlan &&
      FormObject.JobPlan.TaskData &&
      Array.isArray(FormObject.JobPlan.TaskData) &&
      FormObject.JobPlan.TaskData.length === 0
    ) {
      message.info('Please Provide At least One Task');
    } else if (noJobplan === true && !ToolData && !ManPowerData && !MaterialData && !ItemsData && !FieldDataTypeData) {
      let statusResponse = await submitWorkOrder(FormObject, fileUploadList);
      if (statusResponse && statusResponse.message) {
        _getDataById(statusResponse.Id);
        message.success('WorkOrder Submitted Successfully');
        props.navigate('/rubus/AMM/FieldDataMeasurementList');
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    } else {
      if (noJobplan === false) message.error('Please save before you submit');
    }
  };

  const onReset = () => {
    workOrderRef.current.resetFields();
  };

  // const jobPlanOnChange = async (value) => {
  //   let jobplanData = await getJobPlanById(value, 'withoutId');
  //   let formObject =
  //     workOrderRef.current !== null && workOrderRef.current.getFieldsValue()
  //       ? workOrderRef.current.getFieldsValue()
  //       : {};
  //   _.cloneDeepWith(jobplanData['TaskData'], (value) => {
  //     return value !== null && value.StartTime
  //       ? {
  //         ...value,
  //         ...(value['StartTime'] = dayjs.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
  //         ...(value['EndTime'] = dayjs.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
  //       }
  //       : _.noop();
  //   });
  //   formObject = { ...formObject, JobPlan: jobplanData };
  //   workOrderRef.current.setFieldsValue(formObject);
  //   setState(prevState => ({ ...prevState, selectedJobPlan: value, formObject }));
  // };

  // const datepickerchange = (date, dateString, index, key) => {
  //   let formObject = workOrderJobPlanRef.current.getFieldsValue();
  //   let EstimatedDuration = null;
  //   if (
  //     key &&
  //     key === 'EndTime' &&
  //     workOrderJobPlanRef.current.getFieldValue() &&
  //     workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //     workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //     workOrderJobPlanRef.current.getFieldValue().TaskData[index]['StartTime']
  //   ) {
  //     let startTime =
  //       workOrderJobPlanRef.current.getFieldValue() &&
  //       workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //       workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //       workOrderJobPlanRef.current.getFieldValue().TaskData[index]['StartTime'];
  //     let endTime = date;
  //     let ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
  //     let d = dayjs.duration(ms);
  //     EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm:ss');
  //   } else if (
  //     key &&
  //     key === 'StartTime' &&
  //     workOrderJobPlanRef.current.getFieldValue() &&
  //     workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //     workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //     workOrderJobPlanRef.current.getFieldValue().TaskData[index]['EndTime']
  //   ) {
  //     let endTime =
  //       workOrderJobPlanRef.current.getFieldValue() &&
  //       workOrderJobPlanRef.current.getFieldValue().TaskData &&
  //       workOrderJobPlanRef.current.getFieldValue().TaskData[index] &&
  //       workOrderJobPlanRef.current.getFieldValue().TaskData[index]['EndTime'];
  //     let startTime = date;
  //     let ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(dayjs(startTime, 'YYYY-MM-DD HH:mm'));
  //     let d = dayjs.duration(ms);
  //     EstimatedDuration = Math.floor(d.asHours()) + dayjs.utc(ms).format(':mm:ss');
  //   }
  //   formObject['TaskData'][index]['EstimatedDuration'] = EstimatedDuration;
  //   workOrderJobPlanRef.current.setFieldsValue(formObject);
  // };

  const {
    deviceList,
    sitesList,
    selectedJobPlan,
    workTypesList,
    statusList,
    usersList,
    JobPlansList,
    translationCache
  } = state;

  const newLocal = true;
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };

  return (
    <>
      <Form
        name="FieldData"
        ref={workOrderRef}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={validateMessages}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            marginRight: '20px'
          }}
        >
          <Form.Item>
            <Button type="primary" htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <StyledBox>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap'
            }}
          >
            <Form.Item name="Id"></Form.Item>
            <Form.Item
              label={translation(translationCache, constant.workOrder)}
              name="WorkOrder"
              style={{
                width: '100%',
                flex: '50%',
                marginTop: '20px',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              rules={[{ required: true }]}
            >
              <InputComponent
                disabled={true}
                placeholder={translation(translationCache, 'Enter WorkOrderName')}
                value={'WO-11'}
                style={{ width: '70%' }}
                onChange={(e) => handleChange(e.target.value, 'WorkOrder')}
              />
            </Form.Item>
            <Form.Item
              label={translation(translationCache, constant.workOrderDescription)}
              name="Description"
              style={{
                width: '100%',
                flex: '50%',
                marginTop: '20px',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              rules={[{ required: false }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Enter WorkOrderDescription')}
                onChange={(e) => handleChange(e.target.value, 'Description')}
              />
            </Form.Item>
            <Form.Item name="DeviceAlias"></Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.equipment)}
              name="DisplayCode"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select Equipment')}
                onChange={(value) => handleChange(value, 'DeviceId')}
              >
                {deviceList &&
                  Array.isArray(deviceList) &&
                  deviceList.map((device, index) => {
                    return (
                      <Option key={index} value={device.Id}>
                        {' '}
                        {device.Name}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.equipmentDescription)}
              name="EquipmentDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Enter Equipment Description')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.location)}
              name="AssetDisplayCode"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Enter Location')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.locationDescription)}
              name="LocationDescription"
              rules={[{ required: true }]}
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Enter Location Description')}
                disabled={true}
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.createdBy)}
              name="CreatedBy"
            >
              <Select
                placeholder={translation(translationCache, 'Select CreatedBy')}
                style={{ width: '70%' }}
              >
                {usersList &&
                  Array.isArray(usersList) &&
                  usersList.map((item, index) => {
                    return (
                      <Option key={index} value={item.Id}>
                        {' '}
                        {item.FirstName}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.createdDate)}
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              name={'RecordedTime'}
            >
              <DatePicker
                style={{ width: '70%' }}
                format="YYYY-MM-DD HH:mm:ss"
                showTime={{
                  defaultValue: dayjs('00:00:00', 'HH:mm:ss')
                }}
                disabledDate={(d) =>
                  !d || d.isAfter(dayjs().add(1, 'day').format('YYYY-MM-DD'))
                }
              />
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, 'Status')}
              name="WorkOrderStatus"
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select Status')}
                onChange={(value) => handleChange(value, 'StatusId')}
              >
                {statusList.map((status, index) => {
                  return (
                    <Option key={index} value={status.Id}>
                      {' '}
                      {status.Status}{' '}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>

            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.site)}
              name="SiteId"
              disabled={formObject && formObject.Id ? true : false}
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select Site')}
                onChange={(value) => handleChange(value, 'SiteId')}
              >
                {sitesList &&
                  Array.isArray(sitesList) &&
                  sitesList.map((site, index) => {
                    return (
                      <Option key={index} value={site.Id}>
                        {' '}
                        {site.Name}{' '}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.workType)}
              name="WorkTypeId"
              rules={[{ required: true }]}
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select Work Type')}
                onChange={(value) => handleChange(value, 'WorkTypeId')}
              >
                {workTypesList.map((workType, index) => {
                  return (
                    <Option key={index} value={workType.Id}>
                      {' '}
                      {workType.WorkType}{' '}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              style={{ width: '100%', flex: '50%' }}
              name="Attachments"
              label={translation(translationCache, 'Attachments')}
            >
              <FileBase64
                className={'formuploadInput'}
                downloadClassName={'formdownloadInput'}
                Attachments={formObject.Attachments}
                fileUpload={(values, key, fileDataObject) => {
                  fileupload(values, key, fileDataObject);
                }}
              ></FileBase64>
            </Form.Item>

            <Form.Item
              label={translation(translationCache, constant.summary)}
              name={'Summary'}
              style={{ width: '100%', flex: '50%' }}
            >
              <TextArea
                rows={3}
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Enter Summary')}
              />
            </Form.Item>
            <Form.Item style={{ width: '100%', flex: '50%' }}>
              <InputComponent style={{ display: 'none' }} />
            </Form.Item>
          </div>
        </StyledBox>
        <StyledBox>

          <StyledBoxLabel>
            <Typography.Title level={5}>
              {translation(translationCache, 'Jobplan Details')}
            </Typography.Title>
          </StyledBoxLabel>

          <div
            style={{
              display: 'flex',
              justifyContent: 'right',
              marginRight: '20px'
            }}
          >
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.jobPlan)}
              name="JobPlanName"
            >
              <Select
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Select JobPlan')}
                onChange={(value) => handleChange(value, 'JobPlanName')}
              >
                {JobPlansList &&
                  Array.isArray(JobPlansList) &&
                  JobPlansList.map((jobplan, index) => {
                    return (
                      <Option key={index} value={jobplan.Id}>
                        {jobplan.JobPlanName}
                      </Option>
                    );
                  })}
              </Select>
            </Form.Item>
            <Form.Item
              style={{
                width: '100%',
                flex: '50%',
                opacity: newLocal ? 0.75 : 1,
                pointerEvents: newLocal ? 'none' : 'initial'
              }}
              label={translation(translationCache, constant.jobplanDescription)}
              name="JobPlanDescription"
            >
              <InputComponent
                style={{ width: '70%' }}
                placeholder={translation(translationCache, 'Enter Description')}
                onChange={(e) => handleChange(e.target.value, 'Description')}
              />
            </Form.Item>
          </div>

          <Form.Item name="JobPlan">
            {selectedJobPlan === '' ? (
              <WorkOrderJobPlanes
                noJobplan={nojobpaln}
                fileData={state.fileData}
                onFinish={onFinish}
                formObject={formObject['JobPlan']}
                fileUploadList={state.fileUploadList}
                fileUploadListBack={(fileUploadList) => setState(prevState => ({ ...prevState, fileUploadList }))}
              />
            ) : null}
          </Form.Item>
          {/* </Form> */}
        </StyledBox>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WorkOrderForm);